export function makeRequestOptionsWithBody(body) {
    return {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'content-type': 'application/json',
        },
    };
}
